import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import CommonTable, { TableColumn } from "../../components/Table/CommonTable";
import {
  postDetails,
  postMultipartDetails,
} from "../../services/http/http.service";
import APIList from "../../utils/constants/APIList";
import { Trash3Fill, PlusCircleFill } from "react-bootstrap-icons";
import { Button, Modal } from "react-bootstrap";
import CroppingModal from "../../components/Cropping Modal/CroppingModal";
import CustomButton from "../../components/CustomButton/CustomButton";
import InputField from "../../components/InputField/InputField";
import PageHeader from "../../components/PageHeader/PageHeader";
import encrypt from "../../utils/helpers/encrypt";
import { validateImageFile } from "../../utils/helpers/validateFileUpload";
import DatePicker from "react-datepicker";
import { showLoader, hideLoader } from "../../store/Loader/loader.slice";
import { useAppDispatch } from "../../store/storeRequests";
import { showToast, hideToast } from "../../store/Toast/toast.slice";
import { FaCalendarAlt } from "react-icons/fa";
import "./Zoom_Webinar.scss";
import format from "date-fns/format";
import formatDate from "../../utils/helpers/formatDate";

interface Webinar {
  id: number;
  folder_name: string;
  title: string;
  Url: string;
  description: string;
  folder_image: string;
  status: number;
  report: any;
  start_date_time: Date | number;
  end_date_time: Date | number;
  recording_URL: string;
}

interface WebinarPayload {
  title: string;
  folder_name: string;
  description: string;
  id?: number;
  Url: string;
  recording_URL?: string | null;
  start_date_time: any;
  end_date_time: any;
}

const ZoomWebinarData = () => {
  const [showModal, setShowModal] = useState(false);
  const [showCroppingModal, setShowCroppingModal] = useState(false);
  const [folder_name, setFolder_Name] = useState("");
  const [title, setTitle] = useState("");
  const [Url, setUrl] = useState("");
  const [description, setDescription] = useState("");
  const [folderImage, setFolderImage] = useState<{ value: any; src: string }>({
    value: null,
    src: "",
  });
  const [start_date_time, setStart_date_time] = useState<Date | null>(null);
  const [end_date_time, setEnd_date_time] = useState<Date | null>(null);
  const [recording_URL, setRecordingURL] = useState("");
  const [selectedItems, setSelectedItems] = useState<Set<number>>(new Set());
  const [data, setData] = useState<Webinar[]>([]);
  const [isEditing, setIsEditing] = useState(false);
  const [currentItemId, setCurrentItemId] = useState<number | null>(null);
  const [imageChanged, setImageChanged] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [originalData, setOriginalData] = useState<WebinarPayload | null>(null);
  const cmpMounted = useRef(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isEndOpen, setIsEndOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [dateErrors, setDateErrors] = useState({
    startDateError: "",
    endDateError: "",
  });
  // const [urlErrors, setUrlErrors] = useState({
  //   url: "",
  //   recordingUrl: ""
  // });

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (cmpMounted.current) return;
    cmpMounted.current = true;
    fetchZoomWebinarData();
  }, []);

  const handleStartIconClick = () => {
    setIsOpen(!isOpen);
  };

  const handleEndIconClick = () => {
    setIsEndOpen(!isOpen);
  };

  const fetchZoomWebinarData = async () => {
    try {
      dispatch(showLoader("Loading Data..."));
      const response = await postDetails(APIList.GET_ALL_ZOOM_WEBINAR, {});
      console.log("webinar data:", response.data.data);
      if(response.data.data){
           const modifiedData = response.data.data.map((item:any)=>({
            ...item,
            recording_URL: item.recording_URL !== null && item.recording_URL !== "null" ? item.recording_URL : "NA"
            // end_date_time: formatDate(item.end_date_time, "year-month-time"),
            // start_date_time: formatDate(item.start_date_time, "year-month-time")
           }))
           setData(modifiedData);
          //  setData(response.data.data);
      }
      else {
      setData([]);
    }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      dispatch(hideLoader());
    }
  };

  const handleShowModal = () => {
    setTitle("");
    setFolder_Name("");
    setUrl("");
    setDescription("");
    setStart_date_time(null);
    setEnd_date_time(null);
    setRecordingURL("");
    setFolderImage({ value: null, src: "" });
    setShowModal(true);
    setIsEditing(false);
    setCurrentItemId(null);
    setDateErrors({
      startDateError: "",
      endDateError: "",
    })
  };

  const handleCloseDeleteModal = () => setShowDeleteModal(false);
  const handleCloseModal = () => setShowModal(false);

  const handleFolderChange = (e: ChangeEvent<HTMLInputElement>) =>{
    const value = e.target.value;
    // if (/^[A-Za-z0-9\s&?()]*$/.test(value)) {
    setFolder_Name(e.target.value);
    // }
}
  const handleTitleChange = (e: ChangeEvent<HTMLInputElement>) =>{
    const value = e.target.value;
    // if (/^[A-Za-z0-9\s]*$/.test(value)) {
    setTitle(e.target.value);
    // }
}
  const handleUrlChange = (e: ChangeEvent<HTMLInputElement>) =>
    setUrl(e.target.value);

  const handleRecordingURLChange = (e: ChangeEvent<HTMLInputElement>) =>
    setRecordingURL(e.target.value);

  const handleDescriptionChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => setDescription(e.target.value);

  const handleCoverImageChange = (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];

    if (!file) return;

    const validation = validateImageFile(file);
    if (!validation.valid) {
      dispatch(showToast(validation.message));
      setTimeout(() => dispatch(hideToast()), 3000);
      return;
    }

    const maxSize = 11 * 1024 * 1024;
    if (file.size > maxSize) {
      // setErrorMessage(
      //   "File size exceeds the 10MB limit. Please upload a smaller file."
      // );
      dispatch(showToast("File size exceeds the 10MB limit. Please upload a smaller file."));
      setTimeout(() => dispatch(hideToast()), 3000);
      return;
    }

    setFolderImage({
      value: file,
      src: URL.createObjectURL(file),
    });
    setShowCroppingModal(true);
    setImageChanged(true);
  };

  const handleCrop = (croppedImage: string) => {
    setFolderImage((prev) => ({ ...prev, src: croppedImage }));
    setShowCroppingModal(false);
  };

  const removeImage = () => {
    setFolderImage({ value: null, src: "" });
    setImageChanged(true);
  };

  const submitDetails = async (ev: React.FormEvent<HTMLFormElement>) => {
    ev.preventDefault();

    let errors = { startDateError: "", endDateError: "" };
    // const today = new Date();

    // Validate start date (No validation needed since it can be any date)
    if (!start_date_time) {
      errors.startDateError = "Please select a start date.";
    }

    // Validate end date
    if (!end_date_time) {
      errors.endDateError = "Please select an end date.";
    } else if (end_date_time < start_date_time!) {
      errors.endDateError = "End date cannot be earlier than the start date.";
    } 
    // else if (end_date_time > today) {
    //   errors.endDateError = "End date cannot be later than today.";
    // }

    setDateErrors(errors);

    if (start_date_time && end_date_time && start_date_time.getTime() === end_date_time.getTime()) {
      dispatch(showToast("End date and time cannot be the same as start date and time."));
      setTimeout(() => dispatch(hideToast()), 5000);
      return;
    }


    if (!errors.startDateError && !errors.endDateError && !dateErrors.startDateError && !dateErrors.endDateError){

    setDateErrors({
      startDateError: "",
      endDateError: "",
    })

    if (!isEditing && !folderImage.value) {
      // setErrorMessage("Please upload an Image.");
      dispatch(showToast("Please upload an Image."));
      setTimeout(() => dispatch(hideToast()), 3000);
      return;
    }

    const isValidUrl = (Url: string) => {
      const regex = /^(https:\/\/)[^\s/$.?#].[^\s]*$/;
      return regex.test(Url);
    };

    // let urlErrors = { url: "", recordingUrl: "" };

    if (!isValidUrl(Url)) {
      // setErrorMessage("The URL is invalid.");
      dispatch(showToast("The URL is invalid."));
        setTimeout(() => dispatch(hideToast()), 3000);
      return;
    }

    if ( recording_URL && !isValidUrl(recording_URL)) {
      dispatch(showToast("The Recording URL is invalid."));
        setTimeout(() => dispatch(hideToast()), 3000);
      return;
    }

    if (Url === recording_URL) {
      // setErrorMessage("Both URL's can't be the same.");
      dispatch(showToast("Both URL's can't be the same."));
        setTimeout(() => dispatch(hideToast()), 3000);
      return;
    }

    if (
      !folder_name ||
      !title ||
      !description ||
      !end_date_time ||
      !start_date_time
    ) {
      // setErrorMessage("Please fill in all fields.");
      dispatch(showToast("Please fill in all fields."));
        setTimeout(() => dispatch(hideToast()), 3000);
      return;
    }

    const formattedstart_date_time = start_date_time?.toISOString();
    const formattedend_date_time = end_date_time?.toISOString();

    const formData = new FormData();

    if (imageChanged && folderImage.value) {
      formData.append("mediafiles", folderImage.value);
    }

    const trimmedFolderName = folder_name.trim();

    const payload: WebinarPayload = {
      title,
      folder_name: trimmedFolderName,
      Url,
      description,
      start_date_time: formattedstart_date_time,
      end_date_time: formattedend_date_time,
      // recording_URL: recording_URL ? recording_URL : undefined,
      recording_URL: recording_URL === "NA" ? null : recording_URL,
    };

    if (isEditing && currentItemId !== null) {
      payload.id = currentItemId;

      if (isEditing && currentItemId !== null && originalData) {
        const noChanges =
          originalData.title === payload.title &&
          originalData.folder_name === payload.folder_name &&
          originalData.description === payload.description &&
          originalData.Url === payload.Url &&
          originalData.start_date_time === formattedstart_date_time &&
          originalData.end_date_time === formattedend_date_time &&
         ( payload.recording_URL && originalData.recording_URL === payload.recording_URL) &&
          !imageChanged;
    
        if (noChanges) {
          dispatch(showToast("No Changes Done."));
          setTimeout(() => dispatch(hideToast()), 3000);
          return; // Exit the function to prevent API call
        }
    

        payload.recording_URL = recording_URL || "null";
      }
    } else {
      if (!recording_URL) {
        delete payload.recording_URL;
      }
    }

    formData.append("data", encrypt(payload));

    try {
      let response;

      if (isEditing && currentItemId !== null) {
        response = await postMultipartDetails(
          APIList.EDIT_ZOOM_WEBINAR,
          formData
        );
        // console.log(response);
        

        if (response.statusCode === 200) {
          dispatch(showToast("Updated Successfully."));
          fetchZoomWebinarData();
          setShowModal(false);
        } else {
          
          // dispatch(showToast(`Failed to Update: ${response.message}`));
          dispatch(showToast(`Failed to Update: As the start date of the Event Passed...`));

        }
      } else {
        response = await postMultipartDetails(
          APIList.ADD_ZOOM_WEBINAR,
          formData
        );
        if (response.statusCode === 200) {
          dispatch(showToast("Added Successfully."));
          setFolder_Name("");
          setTitle("");
          setUrl("");
          setDescription("");
          setFolderImage({ value: null, src: "" });
          setStart_date_time(null);
          setEnd_date_time(null);
          setRecordingURL("");
          setShowModal(false);
          fetchZoomWebinarData();
        } else {
          dispatch(showToast(`Failed to Add: ${response.message}`));
        }
      }
    } catch (error) {
      dispatch(showToast("Some error occurred while submitting data."));
      console.error("Error submitting details:", error);
    } finally {
      setTimeout(() => dispatch(hideToast()), 3000);
    }
  }
  };

  const editItem = (item: Webinar) => {
    setErrorMessage("");
    setFolder_Name(item.folder_name || "");
    setTitle(item.title || "");
    setUrl(item.Url || "");
    setDescription(item.description || "");
    setFolderImage({ value: null, src: item.folder_image || "" });
    setStart_date_time(
      item.start_date_time ? new Date(item.start_date_time) : null
    );
    setEnd_date_time(item.end_date_time ? new Date(item.end_date_time) : null);
    setRecordingURL(item.recording_URL === "NA" ? "" : item.recording_URL);
    setIsEditing(true);
    setCurrentItemId(item.id);
    setShowModal(true);
    setOriginalData({
      folder_name: item.folder_name,
      description: item.description,
      title: item.title,
      Url: item.Url,
      start_date_time: item.start_date_time,
      end_date_time: item.end_date_time,
      // recording_URL: item.recording_URL || "null",
      recording_URL: item.recording_URL === "NA" ? "" : item.recording_URL,
    });
    setImageChanged(false);
  };

  // console.log(start_date_time.toISOString(), end_date_time.toISOString())
// Check if the current date has passed the start date


  const deleteItemById = async (item: Webinar) => {
    try {
      const response = await postDetails(APIList.DELETE_ZOOM_WEBINAR, {
        id: item.id,
      });

      if (response.status === "Failed") {
        console.log("Cannot delete folder");
        return;
      }

      setData((prevData) => prevData.filter((row) => row.id !== item.id));
      console.log("Folder deleted");
      dispatch(showToast("Deleted Succesfully."));
      setTimeout(() => dispatch(hideToast()), 3000);
    } catch (error) {
      console.error("Error deleting folder:", error);
    }
  };

  const handleCheckboxChange = (selectedIds: Set<number>) => {
    console.log(selectedIds);
    setSelectedItems(selectedIds);
  };

  const handleCancelCrop = () => {
    // Close the cropping modal without setting the image
    // setFolderImage({ value: null, src: "" }); // Reset the folder image
    setFolderImage((prev) => ({ ...prev, value: null, src: "" }));
    setShowCroppingModal(false); // Close the cropping modal
  };

  const handleBulkDelete = async () => {
    try {
      for (const id of selectedItems) {
        const itemToDelete = data.find((item) => item.id === id);
        if (itemToDelete) {
          await deleteItemById(itemToDelete);
        }
      }
      setSelectedItems(new Set());
      setShowDeleteModal(false);
    } catch (error) {
      console.error("Error deleting items:", error);
    }
  };

  const toggleStatus = async (item: Webinar) => {
    try {
      const newStatus = item.status === 0 ? 1 : 0;
      const response = await postDetails(APIList.ZOOM_WEBINAR_STATUS_UPDATE, {
        id: item.id,
        status: newStatus,
      });

      if (response.status === "Failed") {
        console.log("Cannot update status");
        return;
      }

      setData((prevData) =>
        prevData.map((row) =>
          row.id === item.id ? { ...row, status: newStatus } : row
        )
      );
      console.log("Status updated");
      dispatch(showToast("Status Successfully Updated."));
      setTimeout(() => dispatch(hideToast()), 3000);
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };

  const handleCancel = () => {
    setFolder_Name("");
    setTitle("");
    setUrl("");
    setDescription("");
    setFolderImage({ value: null, src: "" });
    setStart_date_time(null);
    setEnd_date_time(null);
    setShowModal(false);
    setErrorMessage("");
  };

  const handlestart_date_timeChange = (date: Date | null) => {
    // if (!date) return;
    if(date)
{
    const now = new Date();
    const selectedDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

    // Check if selected date is earlier than today
    // if (date < now) {
    //   dispatch(showToast(`Start date and time cannot be earlier than today`));
    //   setTimeout(() => dispatch(hideToast()), 3000);
    //   return;
    // }

    if (selectedDate < today) {
      dispatch(showToast(`Start date and time cannot be earlier than today`));
      setTimeout(() => dispatch(hideToast()), 3000);
      // setDateErrors((prev) => ({
      //   ...prev,
      //   startDateError: "Start date and time cannot be earlier than today",
      // }));
      return;
    }

    // If today is selected, check if the selected time is earlier than current time
    if (selectedDate.getTime() === today.getTime() && date < now) {
      dispatch(showToast(`Start time cannot be earlier than the current time`));
      setTimeout(() => dispatch(hideToast()), 3000);
      // setDateErrors((prev) => ({
      //   ...prev,
      //   startDateError: "Start time cannot be earlier than the current time",
      // }));
      return;
    }

    setStart_date_time(date);
    setIsOpen(false);
    if (end_date_time && date && date.getTime() === end_date_time.getTime()) {
      setDateErrors((prev) => ({
        ...prev,
        startDateError: "Start date and end date cannot be the same",
      }));
    } else {
      setDateErrors((prev) => ({
        ...prev,
        startDateError: '',
      }));
    }} else {
      setStart_date_time(null);
    }
  };

  const handleend_date_timeChange = (date: Date | null) => {
    // if (!date) return;

    if(date){
    const now = new Date();

    // Check if selected date is earlier than today
    if (date < now) {
      dispatch(showToast(`End date and time cannot be earlier than today`));
      setTimeout(() => dispatch(hideToast()), 3000);
      return;
    }
    setEnd_date_time(date);
    setIsEndOpen(false);
    // if (start_date_time && date && date.getTime() <= start_date_time.getTime()) {
    
    //   setDateErrors((prev) => ({
    //     ...prev,
    //     endDateError: "End date cannot be the same as or before the start date",
    //   }));
    // } else {
    //   setDateErrors((prev) => ({
    //     ...prev,
    //     endDateError: '',
    //   }));
    // }
  } 
    else{
      setEnd_date_time(null);
    }
  };

  const columns: TableColumn[] = [
    {
      key: "folder_name",
      label: "Folder Name",
      sortable: true,
      dataType: "string",
    },
    // { key: "title", label: "Title", sortable: true, dataType: "string" },
    { key: "Url", label: "Url", dataType: "string" },
    // { key: "description", label: "Contest Text", dataType: "string" },
    { key: "recording_URL", label: "Recording URL", dataType: "string",
        //  render: (item)=> item.recording_URL !== null && item.recording_URL !== "null" ? item.recording_URL : "NA"
    },
    // {
    //   key: "recording_URL", 
    //   label: "Recording URL", 
    //   render: (recording_URL: any) => {
    //     console.log("recording_URL value:", recording_URL.recording_URL); // Check the value here
    //     return recording_URL.recording_URL && typeof recording_URL === 'string' && recording_URL.trim() !== '' 
    //       ? recording_URL
    //       : 'NA';
    //   }
    // },
    
    
        {
      key: "start_date_time",
      label: "Start Date",
      // dataType: "string"
      render: (record) =>
        new Date(record.start_date_time).toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        }),
    },
    {
      key: "end_date_time",
      label: "End Date",
      // dataType: "string"
      render: (record) =>
        new Date(record.end_date_time).toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        }),
    },
    { key: "folder_image", label: "Folder Image", dataType: "image" },
  ];

  const buttons = [
    {
      label: "Delete",
      theme: "danger",
      icon: <Trash3Fill />,
      onClick: () => setShowDeleteModal(true),
      disabled: selectedItems.size === 0,
    },
    {
      label: "Add New",
      theme: "warning",
      icon: <PlusCircleFill />,
      onClick: handleShowModal,
    },
  ];

  return (
    <div>
      <PageHeader buttons={buttons} />
      <CommonTable<Webinar>
        data={data}
        columns={columns}
        onView={(item) => console.log("View:", item)}
        onEdit={editItem}
        onDelete={deleteItemById}
        onStatusToggle={toggleStatus}
        pagination={true}
        rowsPerPage={10}
        actions={{
          view: false,
          edit: true,
          delete: true,
          checkbox: true,
          status: true,
          showModal: false,
        }}
        onCheckboxChange={handleCheckboxChange}
      />
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>{isEditing ? "Update Details" : "Add New"}</Modal.Title>{" "}
        </Modal.Header>
        <Modal.Body>
          <div
           style={{
            maxHeight: "80vh",
            overflowY: "auto",
            padding: "1rem"
          }}
          >

        
          {errorMessage && (
            <div className="alert alert-danger" role="alert">
              {errorMessage}
            </div>
          )}
          <form onSubmit={submitDetails}>
            <div className="input-wrapper">
              <InputField
                name="folderName"
                label="Folder Name"
                type="text"
                value={folder_name}
                placeholder="Enter Folder Name"
                maxLength={50}
                required={true}
                onChangeInput={handleFolderChange}
              />
              <div className="character-counter">
                {folder_name.length}/{50}
              </div>
            </div>

            <div className="input-wrapper">
              <InputField
                name="title"
                label="Title"
                type="text"
                value={title}
                placeholder="Enter Title"
                maxLength={100}
                required={true}
                onChangeInput={handleTitleChange}
              />
              <div className="character-counter">
                {title.length}/{100}
              </div>
            </div>
            <div className="input-wrapper">
              <InputField
                name="Url"
                label="Url"
                type="text"
                value={Url}
                placeholder="Enter Url"
                required={true}
                onChangeInput={handleUrlChange}
              />
            </div>

            <div className="form-group mb-4">
              <label
                htmlFor="startDate"
                className="weight-500"
                style={{
                  display: "block",
                  marginBottom: "5px",
                  fontSize: "12px",
                }}
              >
                Start Date<span style={{ color: "red" }}>*</span>
              </label>
              <div className="date-picker-container">
              <DatePicker
                    id="startDate"
                    name="startDate"
                    selected={start_date_time}
                    onChange={handlestart_date_timeChange}
                    showTimeSelect
                    isClearable={!isEditing}
                    timeFormat="HH:mm"
                    dateFormat="MMMM d, yyyy h:mm aa"
                    // className="form-control custom-datepicker"
                    className={`mf-admin-inputfield`}
                    placeholderText="Select Date"
                    minDate={new Date()}
                    // minTime={
                    //   start_date_time &&
                    //   start_date_time.toDateString() === new Date().toDateString()
                    //     ? new Date()
                    //     : new Date(new Date().setHours(0, 0, 0, 0))
                    // }
                    minTime={
                      start_date_time === null || start_date_time.toDateString() === new Date().toDateString()
                      ? new Date(0, 0, 0, new Date().getHours(), new Date().getMinutes()) 
                      : new Date(0, 0, 0, 0, 0) 
                    }
                    maxTime={new Date(new Date().setHours(23, 59, 59))}
                    showMonthDropdown 
                  showYearDropdown 
                  dropdownMode="select"
                    timeIntervals={5}
                    readOnly={new Date() > (start_date_time || new Date())} // Disable if start_date_time has passed
                    // open={isOpen}
                    onKeyDown={(e:any)=> {e.preventDefault()}}
                    onClickOutside={() => setIsOpen(false)}
                  />

                {/* <FaCalendarAlt
                  className="calendar-icon"
                  onClick={handleStartIconClick}
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                  }}
                /> */}
                {dateErrors.startDateError && (
                  <div className="error-text font-12 mt-1">{dateErrors.startDateError}</div>
                )}
              </div>
            </div>

            <div className="form-group mb-4">
              <label
                htmlFor="endDate"
                className="weight-500"
                style={{
                  display: "block",
                  marginBottom: "5px",
                  fontSize: "12px",
                }}
              >
                End Date<span style={{ color: "red" }}>*</span>
              </label>
              <div className="date-picker-container">
              <DatePicker
              id="endDate"
              name="endDate"
            selected={end_date_time}
            onChange={handleend_date_timeChange}
            showTimeSelect
            isClearable={!isEditing}
            timeFormat="HH:mm"
            dateFormat="MMMM d, yyyy h:mm aa"
            // className="form-control custom-datepicker"
            className={`mf-admin-inputfield`}
            placeholderText="Select Date"
            minDate={start_date_time || new Date()}
            minTime={
              // end_date_time &&
              // end_date_time.toDateString() === new Date().toDateString()
              //   ? new Date()
              //   : new Date(new Date().setHours(0, 0, 0, 0))
              end_date_time === null || end_date_time.toDateString() === new Date().toDateString()
              ? new Date(0, 0, 0, new Date().getHours(), new Date().getMinutes()) 
              : new Date(0, 0, 0, 0, 0) 
            }
            maxTime={new Date(new Date().setHours(23, 59, 59))}
            timeIntervals={5}
            showMonthDropdown 
                  showYearDropdown 
                  dropdownMode="select"
            readOnly={new Date() > (start_date_time || new Date())} // Disable if start_date_time has passed
            // open={isEndOpen}
            onKeyDown={(e:any)=> {e.preventDefault()}}
            onClickOutside={() => setIsEndOpen(false)}
          />
                {/* <FaCalendarAlt
                  className="calendar-icon"
                  onClick={handleEndIconClick}
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                  }}
                /> */}
                {dateErrors.endDateError && (
                  <div className="error-text font-12 mt-1">{dateErrors.endDateError}</div>
                )}
              </div>
            </div>

            <div className="input-wrapper mt-2">
              <InputField
                name="recording_url"
                label="Recording URL (If Any)"
                type="text"
                value={recording_URL}
                placeholder="Enter Recording URL"
                // maxLength={300}
                required={false}
                onChangeInput={handleRecordingURLChange}
              />
              {/* <div className="character-counter">
                {recording_URL.length}/{300}
              </div> */}
            </div>
            <div className="input-wrapper">
              <InputField
                name="description"
                label="Description"
                type="text"
                value={description}
                placeholder="Enter Description"
                maxLength={150}
                required={true}
                onChangeInput={handleDescriptionChange}
              />
              <div className="character-counter">
                {description.length}/{150}
              </div>
            </div>
            <div className="upload-information mb-4">
              <p className="font-14 mb-2 text-danger fw-bold">
                Uploads must be JPG / JPEG / PNG
                <span style={{ color: "red", fontWeight: "bold" }}>*</span>
              </p>
              <div>
                <div className="upload-image-wrapper d-flex flex-column">
                  {folderImage.src && (
                    <>
                    {/* { !isEditing &&  (<span
                        className="remove-image-btn font-14 cursor-pointer"
                        onClick={removeImage}
                      >
                        Remove
                      </span> ) 
                      } */}
                      <img
                        src={folderImage.src}
                        alt="zoom-webinar-image"
                        width={150}
                      />
                    </>
                  )}
                </div>
              </div>
              <label htmlFor="photo">
                <div className="upload-btn-wrapper font-14 d-flex align-items-center justify-content-center gap-1">
                  <i className="fa-regular fa-image"></i>
                  <span>
                    {folderImage.src ? "Change Photo" : "Upload Folder Image"}
                  </span>
                </div>
              </label>
              <InputField
                type="file"
                name="photo"
                id="photo"
                value={""}
                className="d-none"
                onChangeInput={handleCoverImageChange}
              />
            </div>

            <div className="add-zoom-webinar-btn-bottom d-flex flex-column-reverse flex-md-row align-items-md-center justify-content-md-center gap-3 mb-3">
              <CustomButton theme="red" size="md" onClick={handleCancel}>
                Cancel
              </CustomButton>
              <CustomButton theme="yellow" size="md" type="submit">
                Submit
              </CustomButton>
            </div>
          </form>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={showDeleteModal}
        onHide={handleCloseDeleteModal}
        centered
        className="deleteAll-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to delete?</p>
          <Button className="btn-danger" onClick={handleBulkDelete}>
            Delete
          </Button>
          <Button
            className="btn-warning text-white"
            onClick={handleCloseDeleteModal}
          >
            Cancel
          </Button>
        </Modal.Body>
      </Modal>

      {/* Cropping Modal */}
      {folderImage.value && (
        <CroppingModal
          show={showCroppingModal}
          handleClose={() => setShowCroppingModal(false)}
          image={folderImage.src}
          onCrop={handleCrop}
          onCancel={handleCancelCrop}
        />
      )}
    </div>
  );
};

export default ZoomWebinarData;
